import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const IVO_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_real-estate-varna/artifacts/jq8zrtmd_Screenshot%202026-07-15%20at%2011.58.35.png";

const PARAGRAPHS = [
  "Не искаме да направим просто поредното събитие за имоти във Варна. Искаме да създадем мястото, на което се срещат хората, които реално определят как ще се развиват градът и имотният му пазар.",
  "Затова поканихме официалните лица, от чиито решения зависи развитието на Варна. Поканихме строителите, които променят облика на града, банките, които финансират пазара, брокерите, които всеки ден виждат какво реално се купува и продава, и инвеститорите, които влагат собствените си средства в имоти.",
  "Това е събитието, на което можете да видите какво се случва във Варна днес и как градът ще се развива оттук нататък.",
  "Искаме веднъж годишно всички тези хора да бъдат в една зала, защото бъдещето на Варна не се определя от един човек или една индустрия. То се определя от решенията и действията на всички тях.",
  "„Играта на Имотите\" ще бъде събитието, на което този разговор се случва.",
];

export default function IvoQuote() {
  return (
    <section
      id="quote"
      data-testid="ivo-quote-section"
      className="relative bg-[#0B1F3D] text-[#F5EBD9] py-24 sm:py-32 lg:py-40 overflow-hidden border-t border-[#F5EBD9]/10"
    >
      <div className="absolute inset-0 sunset-glow opacity-40 pointer-events-none" />

      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="mb-12 lg:mb-16"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#F5892E]" />
            <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5EBD9]/70">
              Пролог — Думите на Иво Димовски
            </span>
          </div>
          <h2 className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl leading-[1.05] max-w-[26ch]">
            „Искаме на едно място да съберем хората, които{" "}
            <span className="text-[#F5892E]">определят бъдещето на Варна</span>."
          </h2>
        </motion.div>

        <div className="grid grid-cols-12 gap-8 lg:gap-14 items-start">
          {/* Portrait */}
          <motion.div
            initial={{ opacity: 0, y: 40, scale: 0.97 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 1, ease: [0.2, 0.8, 0.2, 1] }}
            className="col-span-12 md:col-span-5 lg:col-span-4 lg:col-start-1"
          >
            <div className="relative mx-auto max-w-[340px] md:max-w-none">
              <div
                className="relative overflow-hidden frame-shadow bg-[#0F2647]"
                style={{ aspectRatio: "4/5" }}
              >
                <div
                  className="w-full h-full bg-cover"
                  style={{
                    backgroundImage: `url(${IVO_PORTRAIT})`,
                    backgroundPosition: "center 12%",
                    backgroundSize: "140% auto",
                    backgroundRepeat: "no-repeat",
                  }}
                />
                <div className="absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t from-[#0B1F3D] via-[#0B1F3D]/60 to-transparent pointer-events-none" />
              </div>
              <div className="mt-4">
                <div className="font-display uppercase text-lg text-[#F5EBD9]">
                  Иво Димовски
                </div>
                <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.32em] text-[#F5892E]">
                  Организатор
                </div>
              </div>
            </div>
          </motion.div>

          {/* Quote text */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="col-span-12 md:col-span-7 lg:col-span-7 lg:col-start-6 relative"
          >
            <Quote
              className="absolute -top-6 -left-2 w-16 h-16 sm:w-20 sm:h-20 text-[#F5892E]/25"
              strokeWidth={1}
              fill="currentColor"
            />
            <div className="relative space-y-6 text-lg sm:text-xl text-[#F5EBD9]/85 leading-relaxed">
              {PARAGRAPHS.map((p, i) => (
                <motion.p
                  key={i}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.8, delay: 0.05 * i }}
                  className={i === PARAGRAPHS.length - 1 ? "font-display uppercase text-[#F5EBD9] text-xl sm:text-2xl tracking-tight leading-snug" : ""}
                >
                  {p}
                </motion.p>
              ))}
            </div>
            <div className="mt-8 pt-6 border-t border-[#F5EBD9]/15 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.32em] text-[#F5EBD9]/50">
              — Иво Димовски, Организатор
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
